'use strict';

module.exports = require('./lib/extend');



//////////////////
// WEBPACK FOOTER
// ./~/node.extend/index.js
// module id = 1
// module chunks = 0